import { render, staticRenderFns } from "./hero_items.vue?vue&type=template&id=190f9600&scoped=true&"
import script from "./hero_items.vue?vue&type=script&lang=js&"
export * from "./hero_items.vue?vue&type=script&lang=js&"
import style0 from "./hero_items.vue?vue&type=style&index=0&id=190f9600&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190f9600",
  null
  
)

export default component.exports